import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { RegisterForm } from "#app/components/auth/register-form";

function RegisterScreen() {
  return (
    <AuthLayout
      heading="Create your account"
      legalAction="signing up"
      footerText="Already have an account?"
      footerLinkText="Log in"
      footerLinkHref="/login"
    >
      <RegisterForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/register")({
  component: RegisterScreen,
});
